import MainLayout from "../../components/layouts/MainLayout"
import React, { useCallback, useEffect, useState } from "react";
import { DeleteFilled, EditFilled, EyeFilled,CheckCircleFilled,CloseCircleFilled,MinusCircleFilled } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { message, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { annonceApi } from "../../api/annonceApi";
import { DateFormat } from "../../utils/formatDate";
import { CommandeApi } from "../../api/commandeApi";
import Money from "../../components/Money";

// import { annonceApi } from "../../api/annonceApi";

const ListCommandesView = () =>{

    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [order, setOrder] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const itemsPerPage = 15
    const [currentPage, setCurrentPage] = useState(1)
    const now = new Date();
    const date_now = now.getFullYear() + "-" + 
          String(now.getMonth() + 1).padStart(2, "0") + "-" + 
          String(now.getDate()).padStart(2, "0") + " " + 
          String(now.getHours()).padStart(2, "0") + ":" + 
          String(now.getMinutes()).padStart(2, "0") + ":" + 
          String(now.getSeconds()).padStart(2, "0");
    
    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await CommandeApi.getCommandes(abortController.signal)
          
 
            if(!res){
                setLoading(false)
                   return;

            }            
            
            setOrder(res.data)
            setLoading(false)
            // console.log(categories)
 
         } catch (error) {
             console.log(error)

            setLoading(false)
            const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                if(messages.join('\n') === 'Unauthenticated'){
                    Auth.removeSessionToken()
                    return navigate(`/login`)
                }   
                        
              });
 
         }
    }

    const handleDetail = (order) => {
        // console.log("ID mecano",order.id)
        if(order.id)
            return navigate(`/commandes/${order.id}/details`)
        
    }
    const handleDelete = async (order) => {
        try {
            const res = await CommandeApi.deleteCommande(`${order.id}`,abortController.signal)

            if (res.success === true) {
                message.success(res.message);
            }else{
                message.error(res.message);

            }

            handlefetchdata()
            
        } catch (error) {
            console.error(error);
            setLoading(false);
            message.error("Échec de suppression des informations");
        }
    }

    const handleAddOrder = () =>{
        navigate('/ajouter-commande')
    }
    const handleStatusChange = async (orderId, newStatus) => {
        console.log("update status")
        try{
            const payload = {
                status:newStatus
            }
            const res = await CommandeApi.updateStatus(orderId,JSON.stringify(payload),abortController.signal)
            setOrder(prevItems =>
                prevItems.map(item =>
                    item.id === orderId ? { ...item, status: newStatus } : item
                )                
            );

            if (res.success === true) {
                message.success(res.message);
            }else{
                message.error(res.message);

            }
        }catch (error) {
            console.error(error);
            setLoading(false);
            message.error("Échec de mise a jour du statut de la commande "+order.order_number);
        }
    }

    const handleEdit = (order) => {
        navigate(`/commande/${order.id}/modifier`)
    }

    

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = order.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    useEffect(() => {
            handlefetchdata()
        },[])
    return <MainLayout>
        <div className="container mx-auto p-4">
                <h1 className="text-xl font-bold mb-4">Liste des commandes</h1>
        
                {/* Bouton Ajouter */}
                <button
                  onClick={handleAddOrder}
                  className="mb-4 px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary"
                >
                  Ajouter une commande
                </button>
        
                {/* Table */}
                <table className="min-w-full bg-white border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="py-2 px-4 border-b text-left">No.</th>
                      <th className="py-2 px-4 border-b text-left">Date commande</th>
                      <th className="py-2 px-4 border-b text-left">Client</th>
                      <th className="py-2 px-4 border-b text-left">Vendeur</th>
                      <th className="py-2 px-4 border-b text-left">Article</th>
                      <th className="py-2 px-4 border-b text-left">Montant a negocier</th>
                      <th className="py-2 px-4 border-b text-left">Montant a valide</th>
                      <th className="py-2 px-4 border-b text-left">Commission</th>
                      <th className="py-2 px-4 border-b text-left">Status</th>
                      <th className="py-2 px-4 border-b text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                        <tr>
                        <td colSpan="6" className="text-sm text-center py-4">
                            Chargement des données en cours...
                        </td>
                        </tr>
                    ) : (
                      currentItems.map((order, index) => (
                        <tr key={order.id}>
                            <td className="py-2 px-4 border-b">{order?.order_number}</td>
                            <td className="py-2 px-4 border-b">
                            {DateFormat.formatDate(order?.order_date)  }
                            </td>
                            <td className="py-2 px-4 border-b">{order?.client_id ? order?.client?.name+'-'+order?.customer_number : order?.customer_name+'-'+order?.customer_number}</td>
                            <td className="py-2 px-4 border-b">{order?.annonce ? order?.annonce?.user?.name+'-'+order?.annonce?.user?.lastname :''}</td>
                            <td className="py-2 px-4 border-b">{order?.annonce?.title || ''}</td>
                            <td className="py-2 px-4 border-b">{order?.virtual_amount ? <Money amount={order.virtual_amount} /> : ''}</td>
                            <td className="py-2 px-4 border-b">{order?.total_amount ? <Money amount={order.total_amount} /> : ''}</td>
                            <td className="py-2 px-4 border-b">{order?.commission ? <Money amount={order.commission} /> : ''}</td>
                            
                            <td className="py-2 px-4 border-b">
                                <select
                                    value={order.status}
                                    onChange={(e) => handleStatusChange(order.id, e.target.value)}
                                    className="text-white text-sm rounded-md p-1"
                                    style={{
                                    backgroundColor:
                                        order.status === 'validé en attente de paiement'
                                        ? '#557ceeff' 
                                        : order.status === 'Paiement en cours'
                                        ? 'rgb(177, 238, 85)'
                                        : order.status === 'payée'
                                        ? '#018130ff' 
                                        : order.status === 'en attente de validation'
                                        ? '#374051ff' 
                                        : '#b53a3aff', 
                                    }}
                                >
                                    <option value="en attente de validation">En attente de validation</option>
                                    <option value="Paiement en cours">Paiement en cours</option>
                                    <option value="validé en attente de paiement">Validé en attente de paiement</option>
                                    <option value="payée">Payée</option>
                                    <option value="annulée">Annulée</option>
                                </select>
                                </td>

                            
                            
                            <td className="py-2 px-4 border-b">
                            <EyeFilled
                                className="text-green-600 mr-2 cursor-pointer hover:text-green-800"
                                onClick={() => handleDetail(order)}
                            />
                            <EditFilled className="text-blue-600 mr-2 cursor-pointer hover:text-blue-800" 
                              onClick={() => handleEdit(order) }
        
                            />
                            <DeleteFilled className="text-red-600 cursor-pointer hover:text-red-800"
                              onClick={() => handleDelete(order)}
                            />
        
                            
                            </td>
                        </tr>
                        ))
                    )}
                    </tbody>
        
                </table>
                <div className="flex ml-0 space-x-2 mt-2 justify-end">
                    {Array.from({ length: Math.ceil(order.length / itemsPerPage) }, (_, i) => (
                        <button 
                            key={i} 
                            onClick={() => paginate(i + 1)}
                            className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
              </div>
              {order.length} resultat(s)
    </MainLayout>
}
export default ListCommandesView